<template>
  <article
    v-if="event"
    class="event">

    <div
      v-if="event.stream.live"
      class="event__stream">
      <div v-html="event.stream.code"></div>
    </div>

    <div
      v-else
      class="event__hero">
      <img :src="event.image.sizes['1536x1536']" />
    </div>

    <div class="event__title">
      <h2 v-html="event.name"></h2>
    </div>

    <div class="event__details">
      <div
        v-if="event.custom_date"
        class="event__details-col">
        <p v-html="event.custom_date"></p>
      </div>
      <div
        v-else
        class="event__details-col">
        <p v-html="$formatDateRange(event.start_date, event.end_date)"></p>
        <p v-html="$formatTimeRange(event.start_date, event.start_time, event.end_time)"></p>
      </div>
      <div class="event__details-col">
        <p
          v-if="event.type !== 'online'"
          class="location">
          <span
            v-if="event.location"
            v-html="event.location.map.address"></span>

          <span
            v-else>
            Location TBC
          </span>
        </p>
        <p class="type">
          <span v-if="event.type === 'general'">
            Free
          </span>

          <span v-if="event.type === 'online'">
            Watch it live, online here
          </span>

          <span v-if="event.type === 'ticketed'">
            {{ event.price }}{{ event.price_note }}. Book <a :href="event.booking_link">here</a>
          </span>
        </p>
      </div>
    </div>

    <div class="event__description">
      <div
        class="wysiwyg"
        v-html="event.description"></div>
    </div>

    <div
      v-if="event.location && event.location.note"
      class="event__location">
      <p class="event__location-title">Getting there?</p>
      <p v-html="event.location.note"></p>
    </div>

  </article>
</template>

<script>
export default {
  name: 'Event',
  data() {
    return {
      event: null
    }
  },
  async created() {
    this.event = await this.getEvent()
  },
  methods: {
    getEvent() {
      const url = `${process.env.VUE_APP_API_ADDRESS}/events/${this.$route.params.slug}`

      return new Promise(resolve => {
        fetch(url, {
          headers: this.$headers
        })
          .then(response => response.json())
          .then(result => resolve(result))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.event {
  padding: $page-padding;
  min-height: 100vh;
  z-index: 1;
  background-color: $background;
  width: 100%;
  max-width: $content-width;
  margin: 104px 0 0 0;

  &__stream {
    margin: 0 0 $padding 0;
    /deep/ iframe {
      width: 100%;
      max-width: $content-width;
      height: calc((100vw - #{$page-padding * 2}) / 1.78);
      max-height: calc((#{$content-width} - #{$page-padding * 2}) / 1.78);
    }
  }

  &__hero {
    width: 50%;
    height: calc((50vw - #{$page-padding * 2}) * 0.75);
    max-height: calc((#{$content-width / 2} - #{$page-padding * 2}) * 0.75);
    background-color: $green;
    margin: 0 0 $padding 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 50% 50%;
    }
  }

  &__details {
    margin: 0 0 #{$padding * 3} 0;
    display: flex;

    a {
      text-decoration: underline;
    }

    &-col {
      width: calc(50% - #{$padding / 2});
      margin: 0 $padding 0 0;

      &:nth-child(2n + 2) {
        margin-right: 0px;
      }
    }
  }

  &__location {
    margin: #{$padding * 3} 0 0 0;

    &-title {
      color: $dk-grey;
      text-transform: uppercase;
    }
  }

  @media screen and (max-width: $mobile) {
    margin: calc(55px + #{$padding / 2}) 0 0 0;
    padding: $padding $mobile-padding;

    &__hero {
      width: 100%;
      height: calc(96vw * 0.75);
      margin: 0 0 #{$padding / 2} 0;
    }

    &__details {
      flex-wrap: wrap;
      margin: 0 0 #{$padding * 1} 0;
      &-col {
        width: 100%;
        margin: 0px;
      }
    }
  }
}
</style>
